import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('HotelTravelPolicyModel')
export default class HotelTravelPolicyModel {
  @JsonProperty('id', Number, true) public id: number = -1;
  @JsonProperty('region_type', String, true) public regionType: string = undefined;
  @JsonProperty('region_name', String, true) public regionName: string = undefined;
  @JsonProperty('radius', Number, true) public radius: number = undefined;
  @JsonProperty('max_stars', Number, true) public maxStars: number = undefined;
  @JsonProperty('max_price', Number, true) public maxPrice: number = undefined;
  @JsonProperty('max_price_with_breakfast', Number, true) public maxPriceWithBreakfast: number =
    undefined;
}
